import promotion from './promotion'

export default {
	promotion
}
